import { LomdaV3Content, LomdaV3Metadata } from "./types";

export const DEFAULT_LOMDA_V3_METADATA: LomdaV3Metadata = {
    numOfPages: 0,
    language: "he",
    thumbnailUrl: "",
};

export const DEFAULT_LOMDA_V3_CONTENT: LomdaV3Content = {
    pages: [],
};
